import Help0 from "./help0.jpg";
import Help1 from "./help1.jpg";
import Help2 from "./help2.jpg";

export const HelpImages = [Help0, Help1, Help2];
